import React from 'react'

import omit from 'lodash/omit'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import SignatureDocumentsList, {
  FileUpdates,
} from 'modules/processes/components/ItemWizard/components/Form/Items/Signature/SignatureDocumentsList'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

const SignDocuments = () => {
  const { associatedTaskItem: item, form } = useFormProvider()

  const [files, setFiles] = React.useState<FileUpdates>()

  const configuration = form.get('task_type_configuration')

  const folderId = configuration.value && configuration?.value['folder_id']

  const additionalFormData = form.get('additional_form_data')

  const setSignatureFiles = () => {
    const filesToRemove = files?.filesToRemove

    if (!!(files?.filesToAdd.length || files?.filesToRemove.size)) {
      additionalFormData.set({
        ...additionalFormData.value,
        [TaskConfigurationTypes.SignDocuments]: {
          signatureDocuments: {
            filesToAdd: files?.filesToAdd,
            ...(filesToRemove && { filesToRemove: Array.from(filesToRemove) }),
          },
        },
      })
    } else {
      additionalFormData.set(omit(additionalFormData.value, TaskConfigurationTypes.SignDocuments))
    }
  }

  useUnsafeEffect(() => {
    setSignatureFiles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files])

  return <SignatureDocumentsList item={item} onFileUpdates={setFiles} folderId={folderId} />
}

export default SignDocuments
